import configs from '@/configs'
import _ from "lodash";
import { currency } from "@/commons/currency";
import moment from "moment"
import { sendErrorNotice, refreshResource } from "@/commons/utils";

export function request_header(token) {
  return {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "accept": "application/json",
  };
}

export function request_payload(param) {
  let query = '';
  if(param && (param.pagination || param.qObject || param.filter || param.quickFilter)) {
    const page = param.pagination && param.pagination.page ? param.pagination.page : 1
    const rowsPerPage = param.pagination && param.pagination.itemsPerPage ? param.pagination.itemsPerPage : 1000000
    const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
    const descending = param.pagination ? param.pagination.sortDesc[0] : 1
    const qObject = param.qObject ? Buffer.from(JSON.stringify({ qObject: param.qObject })).toString("base64") : '';
    const filter = param.filter && param.filter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.filter })).toString("base64") : '';
    const quickFilter = param.quickFilter && param.quickFilter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString("base64") : '';
    query = `?filter=${filter}&qObject=${qObject}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}&q=${quickFilter}`;

    if('startTime' in param) {
      query += `&startTime=${param.startTime}`
    }
    if('endTime' in param) {
      query += `&endTime=${param.endTime}`
    }
    if('staffName' in param) {
      query += `&staffName=${param.staffName}`
    }
    if('method' in param) {
      query += `&method=${param.method}`
    }
  }
  else if(param && param.is_master) {
    const is_master = param.is_master || '';
    const fields = param.fields || [];
    query = `?is_master=${is_master}&fields=${fields.join(',')}`;
  }
  else if(param) {
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = `?${fields.join('&')}`;
  }

  if(param && 'bell' in param) {
    query += `&bell=${param.bell}`
  }
  return query;
}

export function request_list(endpoint, cb, $http, param, token) {
  const req = {
    headers: request_header(token)
  };
  
  const query = request_payload(param);

  $http.get(`${configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT}/admin/api/${endpoint}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
  });
}

export function export_list(endpoint, cb, $http, param, token) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  
  const query = request_payload(param)

  $http.get(`${configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT}/admin/api/${endpoint}/export/${query}`, req).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function request_detail(endpoint, cb, $http, id, token, param) {
  const header = {
    headers: request_header(token)
  };
  let query = '';
  if(param) {
    if(param.pagination) {
      const page = param.pagination ? param.pagination.page : 1
      const rowsPerPage = param.pagination ? param.pagination.itemsPerPage : 1000000
      const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
      const descending = param.pagination ? param.pagination.sortDesc[0] : 1
      query = `?page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}`;
      delete param.pagination;
    }
    if(param.filter) {
      const filter = param.filter && param.filter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.filter })).toString("base64") : '';
      query = query + (query == '' ? '?' : '&') + `filter=${filter}`;
      delete param.filter;
    }
    if(param.quickFilter) {
      const quickFilter = param.quickFilter && param.quickFilter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString("base64") : ''; 
      query = query + (query == '' ? '?' : '&') + `q=${quickFilter}`;
      delete param.quickFilter;
    }
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = query == '' ? `?${fields.join('&')}` : `${query}&${fields.join('&')}`;
  }
  $http.get(`${configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT}/admin/api/${endpoint}/${id}${query}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
  });
}

export function update_detail(endpoint, cb, $http, param, pId, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  let path = pId == 0 ? `${configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT}/admin/api/${endpoint}/` : `${configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT}/admin/api/${endpoint}/${pId}`;
  $http.post(path, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
      refreshResource();
    }
  });
}

export function remove_detail(endpoint, cb, $http, id, token) {
  const header = {
    headers: request_header(token)
  };
  $http.delete(`${configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT}/admin/api/${endpoint}/${id}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  });
}

export function create_detail(endpoint, cb, $http, param, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  delete req['ID'];
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  $http.put(`${configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT}/admin/api/${endpoint}/`, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
      refreshResource();
    }
  });
}

export function comment_type(value) {
  const cmtType = configs.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.name : '';
}

export function comment_type_color(value) {
  const cmtType = configs.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.color : '#e6c87f';
}

export function comment_avatar(value) {
  if (value !== null) {
    return '/android-icon-96x96.png';
  }
  return '/static/avatar/no_avatar.png';
}

export function comment_color(value) {
  if (value) {
    return '#ff0000';
  }
  return '#0000ff';
}

export function payment_type(value) {
  switch (value) {
    case 2:
    case 3:
      return "Đặt cọc";
    case 12:
      return "Hoàn tiền"
    default:
      return "Thanh toán";
  }
}

export function payment_type_color(value) {
  switch (value) {
    case 2:
      return "#e6c87f";
    case 3:
      return "#ffff00";
    case 12:
      return "#ff0000"
    default:
      return "#0000ff";
  }
}

export function complain_type(value) {
  switch (value) {
    case 1:
      return "Chờ xử lý";
    case 2:
      return "Đang xử lý";
    case 3:
      return "Đã xử lý"
    default:
      return "Đã hủy";
  }
}

export function complain_type_color(value) {
  switch (value) {
    case 1:
      return "#ff0000";
    case 2:
      return "#797960";
    case 3:
      return "#0000ff"
    default:
      return "#e6c87f";
  }
}

export function trade_type(value) {
  const cmtType = configs.TRADE_TYPE.find(obj => obj.value === value);
  return cmtType ? cmtType.name : '';
}

export function print_transaction(weight, weight_v2, length, width, height, transactionCode, customerName, orderId, numberOfCode) {
  var mywindow = window.open("", "PRINT");

  mywindow.document.write("<html><head><title></title>");
  mywindow.document.write(
    "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
  );
  mywindow.document.write(
    ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
  );
  mywindow.document.write(
    ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 18px; font-weight: bold; font-style: italic; text-align: center;}"
  );
  mywindow.document.write(
    "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
  );
  mywindow.document.write("<div class='layout wrap'>");
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${customerName}</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><hr class='v-divider theme--light'></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${orderId}</p></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Số kiện</p></div><div class='flex lg6'><p class='sub-title r-text'>${numberOfCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${weight > weight_v2 ? weight : weight_v2} kg</p></div></div>`
  );
  if(weight_v2 > weight) {
    mywindow.document.write(
      `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Kích thước (cm)</p></div><div class='flex lg6'><p class='sub-title r-text'>${length} x ${width} x ${height}</p></div></div>`
    );
  }
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Mã bill</p></div><div class='flex lg6'><p class='sub-title r-text'>${transactionCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
      new Date()
    ).format("DD-MM-YYYY")}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Lưu ý</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Qúy khách vui lòng giữ lại mã bill Trung Quốc để sử dụng trong trường hợp khiếu nại với shop.</p></div>`
  );
  mywindow.document.write(`<hr class='v-divider theme--light'>`);
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>${configs.SYSTEM_CONFIG.domain}</p></div>`
  );
  mywindow.document.write("</div>");
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  mywindow.close();
  return true;
}

export function print_transaction_v2(item, staffName, render = false) {
  const frame_printing = `<html>
  <head>
      <title></title>
      <script src="https://cdn.jsdelivr.net/jsbarcode/3.5.1/JsBarcode.all.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/davidshimjs-qrcodejs@0.0.2/qrcode.min.js"></script>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 18px; font-weight: bold; text-align: center; } .sub-title { font-size: 17px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 16px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 16px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 40px; word-wrap: break-word;max-width: 100mm;} @media print { @page { size: auto; margin: 2mm 2mm 2mm 2mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } }
          #background{
            position:absolute;
            z-index:-1;
            background:white;
            display:block;
            min-height:10%; 
            min-width:10%;
          }
          #bg-text
          {
            color:#e6e6e6;
            font-size:50px;
            font-weight:700;
            transform:rotate(330deg);
            -webkit-transform:rotate(330deg);
            margin-left: 30px;
            margin-top: 180px;
          }
      </style>
  </head>
  
  <body style='width:100mm'>
      <div class='layout wrap'>
          <table>
            <tr>
                <td class='title m-text' colspan='6'>Customer Receipt</td>
            </tr>
            <tr>
                <td class='m-text' colspan='6'>
                  <svg id="vncode128"></svg>
                  <br/>
                  <span>Mã đơn hàng: ${item.TransactionCode}</span>
                  <br/>
                  <span>Mã vận đơn: ${item.TransactionCodeVN}</span>
                </td>
            </tr>
            <tr>
                <td class='sub-title' colspan='6'>From: ${item.FakeShopName}</br>${item.FakeShopAddress}</td>
            </tr>
            <tr>
                <td class='sub-title' colspan='6'>To: ${item.FakeCustomerName} | +${item.FakeCustomerPhone}</td>
            </tr>
            <tr>
                <td class='body-text' colspan='6'>${item.FakeCustomerAddress}</td>
            </tr>
            <tr>
                <td class='body-text m-text' colspan='3'>${staffName}</td>
                <td class='sub-title m-text' colspan='3'>${item.Username}</td>
            </tr>
            <tr>
                <td class='m-text' rowspan='2' colspan='3'><div id="qrcode" style="margin-left: 80px"></div></td>
                <td class='body-text m-text' colspan='3'>Trọng lượng</td>
            </tr>
            <tr>
                <td class='sub-title m-text' colspan='3'>${ currency(item.ChinaWeight, '', 1)}kg</td>
            </tr>
            <tr>
                <td class='body-text m-text' colspan='6'>${moment(item.FakePrintDate).format("DD/MM/YYYY hh:mm A")}</td>
            </tr>
            <tr>
                <td class='body-text m-text' colspan='6'>Hàng hóa thông quan điện tử</td>
            </tr>
            <tr>
                <td class='sub-title m-text' colspan='6'>Không mở gói hàng, không đồng kiểm</td>
            </tr> 
            <tr>
                <td class='body-text m-text' colspan='6'>${item.ProductName}</td>
            </tr>
          </table>
      </div>
      <script>
        new QRCode(document.getElementById("qrcode"), {
          text: "${item.TransactionCode}",
          width: 96,
          height: 96,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : QRCode.CorrectLevel.H
        });
        JsBarcode("#vncode128", "${item.TransactionCode}", {format: "code128", fontSize: 14, height: 50, width: 1.5, textMargin: 2, displayValue: false});
      </script>
  </body>
  </html>`;
  if(render) {
    return frame_printing;
  }
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(frame_printing);
  mywindow.document.close(); // necessary for IE >= 10
  // mywindow.focus(); // necessary for IE >= 10*/
  // mywindow.print();
  // mywindow.close();
  return true;
}

export function print_bigpackage(item, render = false) {
  const frame_printing = `<html>
  <head>
      <title></title>
      <script src="https://cdn.jsdelivr.net/jsbarcode/3.5.1/JsBarcode.all.min.js"></script>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 20px; font-weight: bold; text-align: center; } .sub-title { font-size: 19px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 18px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 18px; } table { border: 1px solid #dddddd; border-collapse: collapse; width: 100%; } td, th { border: 0px solid #dddddd; text-align: left; padding: 1px; } hr { border: 0px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 40px;} @media print { @page { size: auto; margin: 2mm 2mm 2mm 2mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } }
      </style>
  </head>
  
  <body style='width:100mm'>
      <div class='layout wrap'>
          <table>
            <tr>
                <td>${item.CreatedBy} - ${item.ReceivePlaceName}</td>
            </tr>
            <tr>
                <td class='title m-text'>VCN</td>
            </tr>
            <tr>
                <td class='m-text'><svg id="code128"></svg></td>
            </tr>
            <tr>
                <td class='m-text'>Số kiện: <b>${item.NumberOfPack}</b></td>
            </tr>
            <tr>
                <td class='m-text'>Trọng lượng bao: <b>${currency(item.Weight,'',1)}</b></td>
            </tr>
          </table>
      </div>
      <script>
          JsBarcode("#code128", "${item.PackageCode}", {format: "code128", fontSize: 14, height: 50, width: 1.5, textMargin: 2, displayValue: true});
      </script>
  </body>
  </html>`;

  if(render) {
    return frame_printing;
  }

  var mywindow = window.open("", "PRINT");

  mywindow.document.write(frame_printing);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  mywindow.close();
  return true;
}

function pad(num, size) {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

export function print_export_receipt_order(item, packages, render = false) {
  let html_packages = ''
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>${p.TransactionCode}</td>
                        <td class='body-text r-text'>${p.OrderID}</td>
                        <td class='body-text m-text'></td>
                        <td class='body-text r-text'>1</td>
                        <td class='body-text r-text'>${currency(p.Weight,'',2)}</td>
                        <td class='body-text r-text'>${currency(p.Volume,'',3)}</td>
                        <td class='body-text m-text'></td>
                      </tr>`
  }

  const print_content = `<html>
  <head>
      <title></title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 2mm 2mm 2mm 2mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:105mm'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text'>VIETTAOBAO<br/>XNK-VẬN CHUYỂN HÀNG HÓA</td>
                <td class='no-boder sub-title m-text'>PHIẾU XUẤT KHO</td>
              </tr>	
              <tr>
                <td class='no-boder sub-title m-text'>039.739.1688 - 085.285.1688</td>
                <td class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              <tr>        
                <td class='no-boder body-text r-text' colspan='2'>Số phiếu: ${ pad(item.ID, 10) }</td>
              </tr>
              <tr>        
                <td class='no-boder body-text'>Người nhận hàng: ${item.Receiver}</td>
                <td class='no-boder body-text'>Điện thoại: ${item.Phone}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Địa chỉ nhận hàng: ${item.Address}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Lưu ý :<br>
                - Kiểm tra tình trạng hàng hóa trước khi nhận ( trường hợp giao hàng qua bên thứ 3 )<br>
                - Quý khách vui lòng quay lại video mở hàng để được hỗ trợ khiếu nại</td>
              </tr>
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text' rowspan='2'>STT</td>            
                  <td class='sub-title m-text' rowspan='2'>Tên, mã hàng hóa</td>            
                  <td class='sub-title m-text' rowspan='2'>Mã đơn hàng</td>
                  <td class='sub-title m-text' rowspan='2'>ĐVT</td>            
                  <td class='sub-title m-text quantity' rowspan='2'>Số lượng</td>            
                  <td class='sub-title m-text' colspan='2'>Khối lượng</td>            
                  <td class='sub-title m-text' rowspan='2'>Ghi chú</td>
              </tr>
              <tr>                
                  <td class='sub-title r-text width-volumn'>KG</td>
                  <td class='sub-title r-text width-volumn'>Kích thước</td>
              </tr>
              ${html_packages}
              <tr>
                <td class='sub-title m-text' colspan='3'>Tổng số</td>
                <td class='sub-title m-text'></td>
                <td class='sub-title r-text'>${packages.length}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Weight'),'',2)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Volume'),'',3)}</td>
                <td class='sub-title m-text'></td>
              </tr> 
              <tr>
                        <td class='no-boder body-text' colspan='7'><i>Quý khách vui lòng kiểm tra lại mã hàng, số lượng, khối lượng khi nhận hàng!</i></td>
                    </tr> 
              <tr>
                        <td class='no-boder body-text' colspan='7'>Tổng số<i>(bằng chữ)</i></td>
                    </tr> 
              <tr>
                        <td class='no-boder body-text' colspan='7'>Chứng từ, giấy tờ kèm theo:</td>
                    </tr> 
              <tr>
                        <td class='no-boder body-text r-text' colspan='7'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
                    </tr> 
              <tr>
                        <td class='no-boder body-text m-text' colspan='2'>Người lập phiếu<br/><i>(Ký, họ tên)</i></td>
                        <td class='no-boder body-text m-text' colspan='2'>Thủ kho<br/><i>(Ký, họ tên)</i></td>
                        <td class='no-boder body-text m-text' colspan='1'>Lái xe<br/><i>(Ký, họ tên)</i></td>
                        <td class='no-boder body-text m-text' colspan='2'>Người nhận hàng<br/><i>(Ký, họ tên)</i></td>
                    </tr> 
                    <tr>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                        <td class='no-boder body-text m-text' colspan='1'></td>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                    </tr> 
                    <tr>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                        <td class='no-boder body-text m-text' colspan='1'></td>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                    </tr> 
                    <tr>
                      <td class='no-boder body-text m-text' colspan='2'>${item.Voter}</td>
                      <td class='no-boder body-text m-text' colspan='2'></td>
                      <td class='no-boder body-text m-text' colspan='1'></td>
                      <td class='no-boder body-text m-text' colspan='2'></td>
                  </tr> 
                </table>
            </div>
        </body>
  </html>`;
  if(render) {
    return print_content;
  }
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(print_content);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  // mywindow.close();
  return true;
}

export function print_export_receipt_deposit(item, packages, render = false) {
  let html_packages = ''
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>${p.TransactionCode}</td>
                        <td class='body-text r-text quantity'>1</td>
                        <td class='body-text r-text'>${currency(p.Weight,'',1)}</td>
                        <td class='body-text r-text'>${currency(p.Volume,'',1)}</td>
                        <td class='body-text m-text'></td>
                      </tr>`
  }

  const print_content = `<html>
  <head>
      <title></title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 2mm 2mm 2mm 2mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:105mm'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text'>VIETTAOBAO<br/>XNK-VẬN CHUYỂN HÀNG HÓA</td>
                <td class='no-boder sub-title m-text'>PHIẾU XUẤT KHO</td>
              </tr>	
              <tr>
                <td class='no-boder sub-title m-text'>076.365.1688 - 0707.119.119</td>
                <td class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              <tr>        
                <td class='no-boder body-text r-text' colspan='2'>Số phiếu: ${ pad(item.ID, 10) }</td>
              </tr>
              <tr>        
                <td class='no-boder body-text'>Người nhận hàng: ${item.Receiver}</td>
                <td class='no-boder body-text'>Điện thoại: ${item.Phone}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Địa chỉ nhận hàng: ${item.Address}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Lưu ý :<br>
                - Kiểm tra tình trạng hàng hóa trước khi nhận ( trường hợp giao hàng qua bên thứ 3 )<br>
                - Quý khách vui lòng quay lại video mở hàng để được hỗ trợ khiếu nại</td>
              </tr>
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text' rowspan='2'>STT</td>            
                  <td class='sub-title m-text' rowspan='2'>Tên, mã hàng hóa</td>
                  <td class='sub-title m-text quantity' rowspan='2'>Số lượng</td>            
                  <td class='sub-title m-text' colspan='2'>Khối lượng</td>            
                  <td class='sub-title m-text' rowspan='2'>Ghi chú</td>
              </tr>
              <tr>                
                  <td class='sub-title r-text width-volumn'>KG</td>
                  <td class='sub-title r-text width-volumn'>Kích thước</td>
              </tr>
              ${html_packages}
              <tr>
                <td class='sub-title m-text' colspan='2'>Tổng số</td>
                <td class='sub-title r-text quantity'>${currency(packages.length)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Weight'),'',1)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Volume'),'',1)}</td>
                <td class='sub-title m-text'></td>
              </tr> 
              <tr>
                        <td class='no-boder body-text' colspan='6'><i>Quý khách vui lòng kiểm tra lại mã hàng, số lượng, khối lượng khi nhận hàng!</i></td>
                    </tr> 
              <tr>
                        <td class='no-boder body-text' colspan='6'>Tổng số<i>(bằng chữ)</i></td>
                    </tr> 
              <tr>
                        <td class='no-boder body-text' colspan='6'>Chứng từ, giấy tờ kèm theo:</td>
                    </tr> 
              <tr>
                        <td class='no-boder body-text r-text' colspan='6'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
                    </tr> 
              <tr>
                  <td class='no-boder body-text m-text' colspan='2'>Người lập phiếu<br/><i>(Ký, họ tên)</i></td>
                  <td class='no-boder body-text m-text' colspan='2'>Thủ kho<br/><i>(Ký, họ tên)</i></td>
                  <td class='no-boder body-text m-text' colspan='1'>Lái xe<br/><i>(Ký, họ tên)</i></td>
                  <td class='no-boder body-text m-text' colspan='1'>Người nhận hàng<br/><i>(Ký, họ tên)</i></td>
              </tr> 
              <tr>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                        <td class='no-boder body-text m-text' colspan='1'></td>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                    </tr> 
                    <tr>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                        <td class='no-boder body-text m-text' colspan='1'></td>
                        <td class='no-boder body-text m-text' colspan='2'></td>
                    </tr> 
                    <tr>
                      <td class='no-boder sub-title m-text' colspan='2'>${item.Voter}</td>
                      <td class='no-boder body-text m-text' colspan='2'></td>
                      <td class='no-boder body-text m-text' colspan='1'></td>
                      <td class='no-boder body-text m-text' colspan='2'></td>
                  </tr> 
                </table>
            </div>
        </body>
  </html>`;
  if(render) {
    return print_content;
  }
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(print_content);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  // mywindow.close();
  return true;
}